import * as Yup from 'yup'

export const ContractorNoteSchema = Yup.object().shape({
  note: Yup.string().required('This field is required'),
})
